import { Flex } from 'foundations-components/components/Flex';
import { useEffect, useRef } from 'react';
import RussianBlockedBanner from 'pricing-pages-ui-components/banners/RussianBlockedBanner';
import { isDismissableDesignType } from '../../hooks/useDynamicBanners';
import { trackBannerInteraction } from '../../utils/tracking';
import { DynamicBanner } from 'pricing-pages-ui-components/banners/DynamicBanner';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const PublicBannerSection = ({
  countryCode,
  banners,
  onDismissBanner,
  screen
}) => {
  const trackedBannerNames = useRef(new Set());
  useEffect(() => {
    if (!screen) {
      return;
    }
    for (const {
      banner
    } of banners) {
      const name = String(banner.bannerName);
      if (!trackedBannerNames.current.has(name)) {
        trackedBannerNames.current.add(name);
        trackBannerInteraction({
          action: 'view',
          name,
          screen
        });
      }
    }
  }, [banners, screen]);
  const renderBanners = () => {
    if (countryCode === 'RU') {
      return /*#__PURE__*/_jsx(RussianBlockedBanner, {});
    }
    if (banners.length === 0) {
      return null;
    }
    return /*#__PURE__*/_jsx(_Fragment, {
      children: banners.map(({
        banner,
        purchaseMotionCTA
      }) => /*#__PURE__*/_jsx(DynamicBanner, {
        headline: banner.headline,
        description: typeof banner.description === 'string' ? banner.description : undefined,
        designType: banner.designType,
        bannerType: banner.bannerType,
        purchaseMotionCTA: purchaseMotionCTA,
        onDismiss: isDismissableDesignType(banner.designType) ? () => onDismissBanner(banner) : undefined
      }, String(banner.bannerName)))
    });
  };
  return /*#__PURE__*/_jsx(Flex, {
    display: "flex",
    flexDirection: "column",
    inlineSize: "100%",
    rowGap: "400",
    marginBlockEnd: "400",
    "data-test-id": "public-banner-section-container",
    children: renderBanners()
  });
};